// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1CsyY","list":"PatternAutocomplete_list__3sDK5"};